import React from "react";
import { useForm } from "react-hook-form";
import { useMutation } from "@tanstack/react-query";
import { apiInstance } from "../../../../api/api_Instance";
import styles from "./PartnerForm.module.css";
import { Button } from "../../../../components/ui/button/Button"
import { Link } from "react-router";
import { useHookFormMask } from "use-mask-input";
export const PartnerForm = () => {
    const federalList = [
        { value: 17191, label: "Дальневосточный" },
        { value: 17193, label: "Приволжский" },
        { value: 17192, label: "Северо-Западный" },
        { value: 17195, label: "Северо-Кавказский" },
        { value: 17190, label: "Сибирский" },
        { value: 17196, label: "Уральский" },
        { value: 17194, label: "Центральный" },
        { value: 17189, label: "Южный" },
    ];
    const regionList = [
        { value: 17197, label: "Адыгея" },
        { value: 17198, label: "Алтай" },
        { value: 17199, label: "Алтайский край" },
        { value: 17200, label: "Амурская область" },
        { value: 17201, label: "Архангельская область" },
        { value: 17202, label: "Астраханская область" },
        { value: 17203, label: "Башкортостан" },
        { value: 17204, label: "Белгородская область" },
        { value: 17205, label: "Брянская область" },
        { value: 17206, label: "Бурятия" },
        { value: 17207, label: "Владимирская область" },
        { value: 17208, label: "Волгоградская область" },
        { value: 17209, label: "Вологодская область" },
        { value: 17210, label: "Воронежская область" },
        { value: 17211, label: "Дагестан" },
        { value: 17212, label: "Еврейская АО" },
        { value: 17213, label: "Забайкальский край" },
        { value: 17214, label: "Ивановская область" },
        { value: 17215, label: "Ингушетия" },
        { value: 17216, label: "Иркутская область" },
        { value: 17217, label: "Кабардино-Балкария" },
        { value: 17218, label: "Калининградская область" },
        { value: 17219, label: "Калмыкия" },
        { value: 17220, label: "Калужская область" },
        { value: 17221, label: "Камчатский край" },
        { value: 17222, label: "Карачаево-Черкесия" },
        { value: 17223, label: "Карелия" },
        { value: 17224, label: "Кемеровская область" },
        { value: 17225, label: "Кировская область" },
        { value: 17226, label: "Коми" },
        { value: 17227, label: "Костромская область" },
        { value: 17228, label: "Краснодарский край" },
        { value: 17229, label: "Красноярский край" },
        { value: 17230, label: "Курганская область" },
        { value: 17231, label: "Курская область" },
        { value: 17232, label: "Ленинградская область" },
        { value: 17233, label: "Липецкая область" },
        { value: 17234, label: "Магаданская область" },
        { value: 17235, label: "Марий Эл" },
        { value: 17236, label: "Мордовия" },
        { value: 17237, label: "Москва" },
        { value: 17238, label: "Московская область" },
        { value: 17239, label: "Мурманская область" },
        { value: 17240, label: "Ненецкий Авт. Окр." },
        { value: 17241, label: "Нижегородская область" },
        { value: 17242, label: "Новгородская область" },
        { value: 17243, label: "Новосибирская область" },
        { value: 17244, label: "Омская область" },
        { value: 17245, label: "Оренбургская область" },
        { value: 17246, label: "Орловская область" },
        { value: 17247, label: "Пензенская область" },
        { value: 17248, label: "Пермский край" },
        { value: 17249, label: "Приморский край" },
        { value: 17250, label: "Псковская область" },
        { value: 17251, label: "Ростовская область" },
        { value: 17252, label: "Рязанская область" },
        { value: 17253, label: "Самарская область" },
        { value: 17254, label: "Санкт-Петербург" },
        { value: 17255, label: "Саратовская область" },
        { value: 17256, label: "Сахалинская область" },
        { value: 17257, label: "Свердловская область" },
        { value: 17258, label: "Северная Осетия - Алания" },
        { value: 17259, label: "Смоленская область" },
        { value: 17260, label: "Ставропольский край" },
        { value: 17261, label: "Тамбовская область" },
        { value: 17262, label: "Татарстан" },
        { value: 17263, label: "Тверская область" },
        { value: 17264, label: "Томская область" },
        { value: 17265, label: "Тульская область" },
        { value: 17266, label: "Тыва" },
        { value: 17267, label: "Тюменская область" },
        { value: 17268, label: "Удмуртия" },
        { value: 17269, label: "Ульяновская область" },
        { value: 17270, label: "Хабаровский край" },
        { value: 17271, label: "Хакасия" },
        { value: 17272, label: "Ханты-Мансийский авт. окр." },
        { value: 17273, label: "Челябинская область" },
        { value: 17274, label: "Чечня" },
        { value: 17275, label: "Чувашия" },
        { value: 17276, label: "Чукотский авт. окр." },
        { value: 17277, label: "Якутия" },
        { value: 17278, label: "Ямало-Ненецкий авт. окр." },
        { value: 17279, label: "Ярославская область" }
    ];


    const { register, handleSubmit, formState: { errors }, reset } = useForm();
    const registerWithMask = useHookFormMask(register);
    const mutation = useMutation({
        mutationFn: (data) => apiInstance.post("/api/send_partnership_message/", data),
        onSuccess: () => {
            reset();
        },
        onError: () => {
            alert(`Произошла ошибка`);
        }
    });

    const onSubmit = (data) => {
        const dto = {
            name: data.name,
            phone: data.phone,
            email: data.email,
            federal_district: data.federal_district,
            region: data.region,
            city: data.city,
            business: data.business,
            message: data.message
        }

        mutation.mutate(dto);

    };

    return (
        <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>

            <div className={styles.field}>
                <label>Имя *</label>
                <input {...register("name", { required: "Введите имя" })} />
                {errors.name && <span className={styles.error}>{errors.name.message}</span>}
            </div>

            <div className={styles.field}>
                <label>Телефон *</label>
                <input
                    type="text"
                    {...registerWithMask("phone", "+7 (999) 999-99-99", {
                        required: "Введите телефон"
                    })}
                />
                {errors.phone && (
                    <span className={styles.error}>{errors.phone.message}</span>
                )}
            </div>

            <div className={styles.field}>
                <label>Эл. почта *</label>
                <input
                    type="email"
                    {...register("email", {
                        required: "Введите email",
                        pattern: {
                            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                            message: "Введите корректный email"
                        }
                    })}
                />
                {errors.email && (
                    <span className={styles.error}>{errors.email.message}</span>
                )}
            </div>

            <div className={styles.field}>
                <label>Федеральный округ *</label>
                <select {...register("federal_district", { required: "Выберите округ" })}>
                    <option value="">Выберите...</option>
                    {federalList.map((f) => <option key={f.value} value={f.label}>{f.label}</option>)}
                </select>
                {errors.federal && <span className={styles.error}>{errors.federal.message}</span>}
            </div>

            <div className={styles.field}>
                <label>Район/область *</label>
                <select {...register("region", { required: "Выберите регион" })}>
                    <option value="">Выберите...</option>
                    {regionList.map((r) => <option key={r.value} value={r.label}>{r.label}</option>)}
                </select>
                {errors.region && <span className={styles.error}>{errors.region.message}</span>}
            </div>

            <div className={styles.field}>
                <label>Город</label>
                <input {...register("city")} />
            </div>

            <div className={styles.field}>
                <label>Вид бизнеса</label>
                <input {...register("business")} />
            </div>

            <div className={styles.field}>
                <label>Цель обращения *</label>
                <textarea {...register("message", { required: "Опишите цель обращения" })} />
                {errors.purpose && <span className={styles.error}>{errors.purpose.message}</span>}
            </div>

            <div className={styles.checkbox}>
                <label>
                    <input type="checkbox" {...register("agree", { required: "Необходимо согласие" })} />
                    Согласие на обработку <Link className={styles.link} to="/policy" target="_blank">персональных данных</Link>
                </label>
                {errors.agree && <div className={styles.error}>{errors.agree.message}</div>}
            </div>
            <Button type="submit" variant="yellow" disabled={mutation.isPending}>
                {mutation.isPending ? "Отправка..." : "Отправить заявку"}
            </Button>

        </form>
    );
};
